import {
    User, Briefcase, FolderOpen, Image, Mail, TerminalSquare,
} from "lucide-react";
import AboutWindow from "@/components/os/windows/AboutWindow";
import ExperienceWindow from "@/components/os/windows/ExperienceWindow";
import WorkWindow from "@/components/os/windows/WorkWindow";
import ProjectWindow from "@/components/os/windows/ProjectWindow";
import CertsWindow from "@/components/os/windows/CertsWindow";
import ContactWindow from "@/components/os/windows/ContactWindow";
import TerminalWindow from "@/components/os/windows/TerminalWindow";

export const APPS = {
    about: { title: "bio.txt — Text Editor", short: "About", icon: User, size: "w-[min(94vw,720px)] h-[min(78vh,600px)]" },
    experience: { title: "chronology.csv — Document", short: "Chronology", icon: Briefcase, size: "w-[min(94vw,760px)] h-[min(78vh,600px)]" },
    work: { title: "~/deployments — Files", short: "Deployments", icon: FolderOpen, size: "w-[min(94vw,860px)] h-[min(78vh,620px)]" },
    certificates: { title: "credentials — Image Viewer", short: "Credentials", icon: Image, size: "w-[min(94vw,720px)] h-[min(78vh,580px)]", contentClass: "bg-[#17181c]" },
    contact: { title: "New Message — Mail", short: "Mail", icon: Mail, size: "w-[min(94vw,640px)] h-[min(80vh,640px)]" },
    terminal: { title: "wiki@wikios: ~", short: "Terminal", icon: TerminalSquare, size: "w-[min(94vw,700px)] h-[min(70vh,480px)]", contentClass: "bg-[#0c0e12]" },
};

export const DESKTOP_ICONS = [
    { key: "about", label: "About Me", icon: User, testid: "desktop-icon-about" },
    { key: "experience", label: "Chronology", icon: Briefcase, testid: "desktop-icon-experience" },
    { key: "work", label: "Deployments", icon: FolderOpen, testid: "desktop-icon-work" },
    { key: "certificates", label: "Credentials", icon: Image, testid: "desktop-icon-certificates" },
    { key: "contact", label: "Mail Me", icon: Mail, testid: "desktop-icon-contact", accent: true },
    { key: "terminal", label: "Terminal", icon: TerminalSquare, testid: "desktop-icon-terminal" },
];

export const appMeta = (key) =>
    key.startsWith("project:")
        ? { title: `plate-${key.split(":")[1]} — Viewer`, short: "Plate", icon: Image }
        : APPS[key] || {};

export const renderAppContent = (key, openProject) => {
    if (key.startsWith("project:")) return <ProjectWindow projectId={key.split(":")[1]} />;
    switch (key) {
        case "about": return <AboutWindow />;
        case "experience": return <ExperienceWindow />;
        case "work": return <WorkWindow onOpenProject={openProject} />;
        case "certificates": return <CertsWindow />;
        case "contact": return <ContactWindow />;
        case "terminal": return <TerminalWindow />;
        default: return null;
    }
};
